export const AUTH_SESSION_KEY = "auth_session";
